// Config file added to mirror the code in cog-admin and cog-user and dev-test
const SERVER = process.env.NEXT_PUBLIC_CR_JS_API

if (!SERVER) {
    throw new Error('NEXT_PUBLIC_CR_JS_API not configured')
}

// Make sure the API server doesn't end with a slash
export const API_SERVER = SERVER.endsWith('/') ? SERVER.slice(0, -1) : SERVER